import { defineMessages } from 'react-intl';

export default defineMessages({
    CoverAndBenefits: {
        id: 'cep.components.sgRenewalSphUpgradeTable.CoverAndBenefits',
        defaultMessage: 'Cover and benefits'
    },
    SagaSelect: {
        id: 'cep.components.sgRenewalSphUpgradeTable.SagaSelect',
        defaultMessage: 'Saga Select'
    },
    CurrentCoverLevel: {
        id: 'cep.components.sgRenewalSphUpgradeTable.CurrentCoverLevel',
        defaultMessage: '(Your current cover level)'
    },
    SagaPlus: {
        id: 'cep.components.sgRenewalSphUpgradeTable.SagaPlus',
        defaultMessage: 'Saga Plus'
    },
    ThreeYearFixedPrice: {
        id: 'cep.components.sgRenewalSphUpgradeTable.ThreeYearFixedPrice',
        defaultMessage: '3-year fixed price'
    },
    Bullet1: {
        id: 'cep.components.sgRenewalSphUpgradeTable.Bullet1',
        defaultMessage: 'If nothing changes your price will remain the same for 3-years'
    },
    Bullet2: {
        id: 'cep.components.sgRenewalSphUpgradeTable.Bullet2',
        defaultMessage: 'It\'s the price that\'s fixed, not you - there is no cancellation fee'
    },
    TnCApply: {
        id: 'cep.components.sgRenewalSphUpgradeTable.TnCApply',
        defaultMessage: 'T&Cs apply'
    },
    No: {
        id: 'cep.components.sgRenewalSphUpgradeTable.No',
        defaultMessage: 'No'
    },
    Yes: {
        id: 'cep.components.sgRenewalSphUpgradeTable.Yes',
        defaultMessage: 'Yes'
    },
    UpTo: {
        id: 'cep.components.sgRenewalSphUpgradeTable.UpTo',
        defaultMessage: 'Up to '
    },
    BuildingCover: {
        id: 'cep.components.sgRenewalSphUpgradeTable.BuildingCover',
        defaultMessage: ' buildings cover '
    },
    AndUpTo: {
        id: 'cep.components.sgRenewalSphUpgradeTable.AndUpTo',
        defaultMessage: ' and up to '
    },
    ContentsCover: {
        id: 'cep.components.sgRenewalSphUpgradeTable.ContentsCover',
        defaultMessage: ' contents cover '
    },
    ADinHome: {
        id: 'cep.components.sgRenewalSphUpgradeTable.ADinHome',
        defaultMessage: 'Accidental damage cover in the home'
    },
    ForIncidents: {
        id: 'cep.components.sgRenewalSphUpgradeTable.ForIncidents',
        defaultMessage: ' for incidents such as'
    },
    DroppingLaptop: {
        id: 'cep.components.sgRenewalSphUpgradeTable.DroppingLaptop',
        defaultMessage: ' dropping a laptop or spilling wine on the carpet'
    },
    CombinedLaptop: {
        id: 'cep.components.sgRenewalSphUpgradeTable.CombinedLaptop',
        defaultMessage: ' dropping a laptop, spilling wine on the carpet, putting a hot pan on the worktop or hammering a nail through a pipe'
    },
    HotPan: {
        id: 'cep.components.sgRenewalSphUpgradeTable.HotPan',
        defaultMessage: ' putting a hot pan on the worktop or hammering a nail through a pipe'
    },
    ContentsOnly: {
        id: 'cep.components.sgRenewalSphUpgradeTable.ContentsOnly',
        defaultMessage: 'Contents only'
    },
    BuildingsOnly: {
        id: 'cep.components.sgRenewalSphUpgradeTable.BuildingsOnly',
        defaultMessage: 'Buildings only'
    },
    NotSelected: {
        id: 'cep.components.sgRenewalSphUpgradeTable.NotSelected',
        defaultMessage: 'Not selected'
    },
    PersonalBelongingsCover: {
        id: 'cep.components.sgRenewalSphUpgradeTable.PersonalBelongingsCover',
        defaultMessage: 'Personal belongings cover'
    },
    ForItemsAwayFromHome: {
        id: 'cep.components.sgRenewalSphUpgradeTable.ForItemsAwayFromHome',
        defaultMessage: ' for items away from home such as mobile phones and tablets'
    },
    ReplacementOfSets: {
        id: 'cep.components.sgRenewalSphUpgradeTable.ReplacementOfSets',
        defaultMessage: 'Replacement of matching pairs or sets of items'
    },
    SuchAs: {
        id: 'cep.components.sgRenewalSphUpgradeTable.SuchAs',
        defaultMessage: ' such as'
    },
    Earrings: {
        id: 'cep.components.sgRenewalSphUpgradeTable.Earrings',
        defaultMessage: ' earrings or three-piece suites'
    },
    IfCannotReplace: {
        id: 'cep.components.sgRenewalSphUpgradeTable.IfCannotReplace',
        defaultMessage: ', if we cannot repair or replace individual items to match'
    },
    EarringsOrCabinets: {
        id: 'cep.components.sgRenewalSphUpgradeTable.EarringsOrCabinets',
        defaultMessage: ' earrings, three-piece suites or kitchen cabinets'
    },
    Cabinets: {
        id: 'cep.components.sgRenewalSphUpgradeTable.Cabinets',
        defaultMessage: ' kitchen cabinets'
    },
    TraceAndAccess: {
        id: 'cep.components.sgRenewalSphUpgradeTable.TraceAndAccess',
        defaultMessage: 'Trace and access'
    },
    SourceOfLeak: {
        id: 'cep.components.sgRenewalSphUpgradeTable.SourceOfLeak',
        defaultMessage: ' to locate the source of a water leak that has caused damage to the property'
    },
    UpToFiveK: {
        id: 'cep.components.sgRenewalSphUpgradeTable.UpToFiveK',
        defaultMessage: 'Up to £5,000'
    },
    Scratching: {
        id: 'cep.components.sgRenewalSphUpgradeTable.Scratching',
        defaultMessage: 'Scratching and denting'
    },
    ForExample: {
        id: 'cep.components.sgRenewalSphUpgradeTable.ForExample',
        defaultMessage: ' for example'
    },
    AccidentallyScratchingTable: {
        id: 'cep.components.sgRenewalSphUpgradeTable.UpgradeDividerMessage',
        defaultMessage: ' accidentally scratching your dining room table'
    },
    OrConjunction: {
        id: 'cep.components.sgRenewalSphUpgradeTable.OrConjunction',
        defaultMessage: ' or'
    },
    MovingFurniture: {
        id: 'cep.components.sgRenewalSphUpgradeTable.MovingFurniture',
        defaultMessage: ' moving furniture and scratching the floorboards'
    },
    PetsDamage: {
        id: 'cep.components.sgRenewalSphUpgradeTable.PetsDamage',
        defaultMessage: 'Damage caused by pets'
    },
    ChewsSofa: {
        id: 'cep.components.sgRenewalSphUpgradeTable.ChewsSofa',
        defaultMessage: ' for example, if your dog chews a hole in the sofa'
    }
});
